export default __webpack_public_path__ + "static/media/message.c12fdfe6.png";